"use client";
import { useState } from "react";
import PrimaryBtn from "@/components/PrimaryBtn";

import { Icons, Images } from "@assets/assets";
import Image from "next/image";

const SubscribeCard = () => {
  const [email, setEmail] = useState<string>("");
  const handleSubmit = async () => {
    try {
      const data = await fetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/manager/subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email }),
        },
      ).then((res) => res.json());

      if (data?.success) {
        setEmail("");
      } else {
        setEmail("");
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.log(`Error Found Register Newsletter: ${err.message}`);
      } else {
        console.log("Unknown error occurred");
      }
    }
  };

  return (
    <div className="relative w-full lg:w-[552px] text-white p-[45px] overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <Image
          src={Images?.blogDetails.subscribeBg}
          alt="background"
          fill
          className="object-cover"
          sizes="100vw"
        />
      </div>
      <div className="absolute -right-10 -top-16 w-[365px] h-[365px] rounded-full bg-[#225bd4] blur-[364px] opacity-100" />
      <div className="absolute -left-28 bottom-10 w-[391px] h-[391px] rounded-full bg-[#225bd4] blur-[364px] opacity-100" />
      <div className="relative z-[1] flex flex-col gap-[20px]">
        <div className="flex flex-col gap-[15px]">
          <p className="text-[16px] font-medium">Subscribe to Our Blogs</p>
          <h4 className="text-[28px] leading-tight md:text-[41px] font-medium font-['Clash Display']">
            Join Our Newsletter to get monthly insights and updates
          </h4>
        </div>
        <div className="flex flex-col gap-5">
          <div className="h-[68px] rounded-[70px] border border-white/40 px-[30px] flex items-center text-white/90">
            <input
              type="email"
              placeholder="Input you email"
              className="text-[18px] w-full h-full bg-transparent outline-none font-semibold"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <PrimaryBtn
            text="Subscribe Now"
            iconSrc={Icons?.chevron}
            dark={false}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default SubscribeCard;
